import { Component, OnInit ,ViewChild, AfterViewInit} from '@angular/core';
import { GridBaseCase } from '../../grid/grid.base.case';
import { WebParameterContext } from '../../../../model/common';
import { Platform, IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService } from 'src/service/httpcustomer.service';
import { CommonService } from 'src/service/common.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageclientService } from '../../../../service/messageclient.service';
import { BaseCase } from '../../../basecase';
import { BaseModal } from '../../../../model/base';
import { typeWithParameters } from '@angular/compiler/src/render3/util';
declare var app;

@Component({
  selector: 'app-a2-sign-list',
  templateUrl: './a2-sign-list.component.html',
  styleUrls: ['./a2-sign-list.component.scss']
})
export class A2SignListComponent extends GridBaseCase implements OnInit,AfterViewInit{
  dataArrayList: Array<any> = [];
  productArrayList: Array<any> = [];
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  RecordCount: Number = 0;//列表总数量
  pageName:string = null;
  tabsIndex:number = 0;//tabs默认index
  signPerson = 0;//签到人数
  signOrder = 0;//签到订单数
  salesNum = 0;//销售总数
  newCustomerNum=0;//新客总数
  loading1:boolean = false;//
  searchValue:string="";//搜索条件
  newCustomerList:any = [];//新客列表
  constructor(
    private platform: Platform,
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base:BaseModal
  ) { super();
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
  }

  ngOnInit(){

  }

  /**
   * 关联鲜入为主活动
   * item 当前项数据
   * type 1、新客列表入口；2、销量列表入口
   */
  relationActivity(item,type){
    const _actDetailJumpStatus = localStorage.getItem("actDetailJumpStatus");
    if(_actDetailJumpStatus && _actDetailJumpStatus == "end"){//活动未开始
      this.com.setHistoryUrl();
    }
    const id = this.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    const _obj = {
      actId:id,//妈妈班活动id
      vipId:item["a_FK_MembersInfoManagement_ID"],//顾客消费者id
      milkActId:item["is_Activity"] //鲜入为主活动id
    };
    if(type==2){
      if(!item["a_FK_MembersInfoManagement_ID"]){
        this.msg.Alert("订单还未关联会员，需先绑定会员");
        return;
      }
    }
    // this.router.navigate(["/tabs/contact/ActivityCenterDetail2/getedite/"+_obj.milkActId+"&1&mamaban&"+_obj.actId+"&"+_obj.vipId+"&"+this.com.getNowDatetime]);
    this.com.Go("/tabs/contact/ActivityCenterDetail2/getedite/"+_obj.milkActId+"&1&mamaban&"+_obj.actId+"&"+_obj.vipId+"&"+this.com.getNowDatetime);
  }

  ngAfterViewInit(){
    const that = this;
    let searchArr = that.com.GetStorageKey("searchArray") || [];
    if(searchArr.length > 0){
      searchArr.forEach(item=>{
        if(item.pageName == that.pageName){
          that.searchValue = item.searchInput;
          if(item["selectTabsIndex"] != null && item["selectTabsIndex"] != undefined){
            that.tabsIndex = item["selectTabsIndex"];
          }
          // that.storeId = item.selectItem || null;
          // that.selectText = item["selectText"] || "";
        }
      })
    }
    this.LoadData(1);
  }

  EventLink(event,item){
    // console.log(item);
    this.com.setHistoryUrl();
    // this.router.navigate([event.url+"getedite/"+item.id.value+"&"+this.com.getNowDatetime]);
    this.com.Go(event.url+"getedite/"+item.id.value+"&"+this.com.getNowDatetime);
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.dataArrayList.length) {
      if( that.infiniteScroll){
        that.infiniteScroll.disabled = true;
      }
     
    } else {
      that.PageNumber++;
      this.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber){
    
    let that = this;
    if(that.tabsIndex == 1){
      that.LoadProductData();
    }
    // console.log("1008611");
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // console.log(that.element);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
    let body = new WebParameterContext();
    body.Account = that.com.GetAccount;
    if (that.element.selectItemList.gridViewConfigName) {
      body.ConfigName = that.element.selectItemList.gridViewConfigName;
    }else{
      that.msg.Alert("服务端数据配置有误,请联系管理员");
      return;
    }
    // body.ConfigName="MemberManage";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = app.RowsPerPage;
    body.PageNumber = PageNumber;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.Name = that.element.name;
    body.Client.ClientType = 2;
    if (that.platform.is("android")) {
      body.Client.ClientType = 0;
    } else if (that.platform.is("ios")) {
      body.Client.ClientType = 1;
    }
    let param={};
    param["a_FK_TBActivity_ID"]=id;
    if(that.searchValue){
      param["a_TelPhone"]=that.searchValue;
    }
    body.RequestBody = JSON.stringify(param);
    if(that.tabsIndex == 0){
      body.ConfigName = "TBMemberSign";
    }else if(that.tabsIndex == 1){
      body.ConfigName = "ActivitySalesVolume";
    }else if(that.tabsIndex == 2){
      body.ConfigName = "ActivitySalesVolume";
      body.SpecialParameter = "new";
    }
    let _searchObj = {
      pageName:that.pageName,
      searchInput:that.searchValue,
      selectTabsIndex:that.tabsIndex
    }
    this.com.SaveSearchInfo(_searchObj);
    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if(PageNumber == 1){
        that.dataArrayList = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }else{
        if( that.infiniteScroll){
          that.infiniteScroll.complete();
        }
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        that.signPerson = data.Status.RecordCount;
        that.signOrder = data.Status.OrderNums;
        let reqDatas = data.Status.Datas;

        if(that.tabsIndex == 2){
          var _nArr = [];
          let _jieduan = [];
          that.newCustomerList = [];
          reqDatas.forEach(item=>{
            if(item["a_TelPhone"] && _nArr.indexOf(item["a_TelPhone"]) == -1){
              _nArr.push(item["a_TelPhone"]);
            }
            if(item["a_StageName"]){
              const _index = _jieduan.indexOf(item["a_StageName"]);
              if(_index == -1){
                _jieduan.push(item["a_StageName"]);
                that.newCustomerList.push({
                  Key:item["a_StageName"],
                  code:item["a_StageCode"],
                  Number:1
                });
              }else{
                that.newCustomerList[_index]["Number"] = that.newCustomerList[_index]["Number"] + 1;
              }
            }
          })
          that.newCustomerList.sort(function(a,b){
            if(a["code"] > b["code"]){
              return -1;
            }else{
              return 1;
            }
          });
          that.newCustomerNum = _nArr.length;
        }
        reqDatas.forEach(function (item) {
          // let objfield = {};
          // that.element.selectItemList.selectItem.forEach((element, index) => {
          //   if (element.bindingField) {
          //     objfield[element.bindingField] = { "value": item[element.field], "text": element.text };
          //   }
          //   if(objfield[element.bindingField].value && element.bindingField == "date1"){
          //     objfield[element.bindingField].value = objfield[element.bindingField].value.toString().replace(/-/g,"/");
          //   }
          // });
          if(item.a_ModifyTime){
            item.a_ModifyTime = item.a_ModifyTime.replace(/-/g,"/");
          }
          if(item.c_Register_time){
            item.c_Register_time = item.c_Register_time.replace(/-/g,"/");
          }
          if(item.m_FirstOrderTime){
            item.m_FirstOrderTime = item.m_FirstOrderTime.replace(/-/g,"/");
          }
          if(item.a_FirstOrderTime){
            item.a_FirstOrderTime = item.a_FirstOrderTime.replace(/-/g,"/");
          }
          that.dataArrayList.push(item);
          // console.log(that.element.selectItemList.selectItem);
          
        });


        // console.log(that.dataArrayList);
        //   console.log(that.element);
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount || reqDatas.length;
        if(that.RecordCount == data.Status.Datas.length || that.RecordCount == that.dataArrayList.length){
          // that.infiniteScroll.disabled = true;
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = true;
          }
        }else{
          if( that.infiniteScroll){
            that.infiniteScroll.disabled = false;
          }
        }
        /****上拉加载数据end****/
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
 }
 /**
  * 跳转详细页面
  * @param element 
  * @param item 
  */
 EventClick(element,item){
   const that=this;
   if(element.url){
    that.com.setHistoryUrl();
    // that.router.navigate([element.url+item.id.value]);
    that.com.Go(element.url+item.id.value);
   }
  

 }


 /**
  * tabs切换
  * @param n 
  */
 tabsEvent(n){
  this.tabsIndex = n;
  this.LoadData(1);
  // if(n == 0){
  // }else if(n == 1){
  //   // this.LoadProductData();
  //   this.LoadData(1);
  // }else if(n==2){
  //   this.LoadData(1);
  // }
  let _searchObj = {
    pageName:this.pageName,
    searchInput:this.searchValue,
    selectTabsIndex:this.tabsIndex
  }
  this.com.SaveSearchInfo(_searchObj);
 }

 LoadProductData(){
  let that = this;
  that.loading1 = false;
  that.apiObj['status'] = false;
  that.apiObj['msg'] = '';
  const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
  const id = that.activaRouter.snapshot.paramMap.get('id').split("&")[0];
  let body = new WebParameterContext();
  body.Account = that.com.GetAccount;
  
  body.ConfigName="SummaryMemeberOrderProduct";
  body.OpType = "query";
  body.ConfigType = "view";
  body.RowsPerPage = 100;
  body.PageNumber = 1;
  body.Client.PageName = PageName;
  body.Client.ApiType = "Element";
  body.Client.Name = that.element.name;
  body.Client.ClientType = 2;
  if (that.platform.is("android")) {
    body.Client.ClientType = 0;
  } else if (that.platform.is("ios")) {
    body.Client.ClientType = 1;
  }
  body.RequestBody = JSON.stringify({"a_FK_TBActivity_ID":id});
  that.http.post(app.DEFAULTURL, body).then(data => {
    that.productArrayList = [];
    that.apiObj['status'] = data.ResponseMessage.Success;
    that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
    that.loading1 = true;
    if (data.ResponseMessage.Success) {
      that.productArrayList = data.Status.Datas;
      that.salesNum = 0; 
      data.Status.Datas.forEach((item)=>{
        if(item.Num && item.Num != 0){
          that.salesNum += item.Num;
        }
      })
    }
  }).catch(error => {
    that.apiObj['status'] = false;
    that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
    that.loading1 = true;
    console.log(error);
  });
 }

 //按照姓名或手机号查询
 serarEvent(e,type:string = 'type')
 { 
  let tabsNumn=this.tabsIndex;
  if(e.keyCode == 13 || type=='search'){
    this.LoadData(1);
  }

 }
}
